import "./pathseg.js";
import { PolygonMaskPlugin } from "./PolygonMaskPlugin.js";
export async function loadPolygonMaskPlugin(engine, refresh = true) {
    engine.checkVersion("3.9.1");
    await engine.addPlugin(new PolygonMaskPlugin(engine), refresh);
}
export * from "./Enums/PolygonMaskInlineArrangement.js";
export * from "./Enums/PolygonMaskMoveType.js";
export * from "./Enums/PolygonMaskType.js";
